import Vue from "vue"
import router from "@/router"

import axios from "axios"
import VueAxios from "vue-axios"

Vue.use(VueAxios, axios)

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

export default {
	state: {
		clientAreaAuthenticated: JSON.parse(localStorage.getItem("client-area")) !== null,
		client: null,
		session: 3600 // 1 heure en secondes
	},

	getters: {
		clientAreaAuthenticated(state) {
			return state.clientAreaAuthenticated
		},
		saveClient(state) {
			return state.client
		},
		areaSessionTime(state) {
			return state.session
		}
	},

	mutations: {
		clientAreaAuthenticated(state, payload) {
			state.clientAreaAuthenticated = payload.clientAreaAuthenticated;
		},
		saveClient(state, payload) {
			state.client = payload.client
		},
		updateSession: (state) => {
			state.session = state.session - 1;
		},
		resetSession: (state) => {
			state.session = 3600;
		}
	},

	actions: {
		caLogin(context, payload) {
			return axios.post(`${process.env.VUE_APP_API_CLIENT_AREA_BASE_URL}/login`, payload.user, options)
				.then((response) => {
					context.commit("clientAreaAuthenticated", {
						clientAreaAuthenticated: true,
					})
					return response
				})
		},

		caUpdatePassword(context, payload) {
			return axios.post(`${process.env.VUE_APP_API_CLIENT_AREA_BASE_URL}/update-password`, payload, options)
				.then((response) => {
					context.commit("clientAreaAuthenticated", {
						clientAreaAuthenticated: true,
					})
					return response
				})
		},

		caGetClient({ commit, dispatch }, payload) {
			let localStorageData = JSON.parse(localStorage.getItem("client-area"))
			if(localStorageData) {
				return axios.post(`${process.env.VUE_APP_API_CLIENT_AREA_BASE_URL}/me`, {
				 	access_token: localStorageData.accessToken,
				 	user_type: localStorageData.userType,
				}, options)
					.then((response) => {
						commit("saveClient", {
							client: response.data
						})
					})
					.catch((e) => {
						dispatch("caLogout")
					})
			}
		},

		caLogout(context, payload) {
			context.commit("clientAreaAuthenticated", {
				clientAreaAuthenticated: false
			});
			context.commit("saveClient", {
				client: null
			});
			localStorage.removeItem("client-area")
			router.push({ name: "caLogin" })
		},

		updateSession({commit, dispatch}, params) {
			commit('updateSession')
		},

		resetSession({commit, dispatch}, params) {
			commit('resetSession')
		},
	}
}
